
/*========================
パララックス
========================*/
gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray('.js-parallax').forEach(wrap => {
  const y = wrap.getAttribute('data-y') || -200;

  gsap.to(wrap, {
    y: y,
    scrollTrigger: {
      trigger: wrap,// アニメーションのトリガー要素
      start: 'top bottom',// アニメーション開始位置
      end: 'bottom top',// アニメーション終了位置
      scrub: 1,// 動作を遅らせる
      // markers: true //デバック用マーカー
    }
  })
});

// MVのscroll
$(function(){
  $('#mv .scroll').on('click', function(){
    let introPos = $('#top').offset().top;
    $('.s_pink_html, .s_pink_body').animate({
      scrollTop: introPos
    }, 1000, 'easeOutQuint');
  });
});

/*========================
吹き出し
========================*/
// $(function () {
//   $(window).on('load scroll', function () {
//     $('.scrolltext, .fukidashi').each(function () {
//       var elemPos = $(this).offset().top,
//         scroll = $(window).scrollTop(),
//         windowHeight = $(window).height();
//       if (scroll > elemPos - windowHeight) {
//         $(this).addClass('-visible');
//       }
//     });
//   });
// });

// gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".fukidashi, .scrolltext").forEach((el, index) => {
    ScrollTrigger.create({
        trigger: el,
        id: index+1,
        start: 'top 50%',
        toggleClass: {targets: el, className: "-visible"},
        once: true,
        // markers: true,
    });
});

/*===============================
慣性スクロール
===============================*/
// $(function () {
// 	if ($(window).width() > 640 ) {
// 		luxy.init({
// 			wrapper: '#luxy', // スクロールの対象となる要素を指定
// 			wrapperSpeed: 0.08, // スクロール速度の調整（デフォルト値は0.08）
// 		});
// 	} else {
// 		luxy.init({
// 			wrapper: '#deco_wrap', // スクロールの対象となる要素を指定
// 			wrapperSpeed: 0.00002, // スクロール速度の調整（デフォルト値は0.08）
// 		});
// 	}
// });
